import(/* webpackMode: "eager" */ "/home/oreetiene/public_html/node_modules/next/dist/client/link.js");
